import { useEffect } from "react";

import { ONE_MIN_IN_MS } from "../../constants/durations";
import useViewport from "../../contexts/ViewportContext";
import {
  checkLocalStoragePopupPrevented,
  setLocalStoragePopupPrevented,
} from "./helpers";

export default function useChatPanelAutoOpen(
  chatPanel: BoostChatPanel | null,
  setIsChatPanelOpen: (value: boolean) => void
) {
  const { viewport } = useViewport();

  // If chatPanel is not closed, open panel after time spent on page
  useEffect(() => {
    if (!chatPanel || checkLocalStoragePopupPrevented()) return;

    const timeout = setTimeout(function () {
      chatPanel.show();
      setIsChatPanelOpen(true);
    }, ONE_MIN_IN_MS); // Automatic chat pop-up timer in milliseconds

    return () => {
      clearTimeout(timeout);
    };
  }, [chatPanel, setIsChatPanelOpen]);

  // Disable automatic opening if window viewport in small
  useEffect(() => {
    if (
      (viewport === "xs" || viewport === "sm") &&
      !checkLocalStoragePopupPrevented()
    ) {
      setLocalStoragePopupPrevented(true);
      chatPanel?.minimize();
    }
  }, [chatPanel, viewport]);

  // Disable automatic opening if mobile userAgent is detected
  useEffect(() => {
    const MobileDeviceRegex =
      /Android|webOS|iPhone|iPad|iPod|Mobile|tablet|IEMobile|Windows Phone|Opera Mini/i;

    if (
      MobileDeviceRegex.test(navigator.userAgent) ||
      MobileDeviceRegex.test(navigator.platform)
    ) {
      chatPanel?.minimize();
    }
  }, [chatPanel]);
}
